module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/marika-tarczynska-68a0333035d60837fbbd4028f85d4fde.png";